const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/get-all-articles.action';
            binding.dataActions[actionPath] = require('partner/actions/get-all-articles.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-all-item-references.action';
            binding.dataActions[actionPath] = require('partner/actions/get-all-item-references.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-article-tags.action';
            binding.dataActions[actionPath] = require('partner/actions/get-article-tags.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-article.action';
            binding.dataActions[actionPath] = require('partner/actions/get-article.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-auto-suggest-suggestions.action';
            binding.dataActions[actionPath] = require('partner/actions/get-auto-suggest-suggestions.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-cart-staging-data.action';
            binding.dataActions[actionPath] = require('partner/actions/get-cart-staging-data.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-ftp-documents.action';
            binding.dataActions[actionPath] = require('partner/actions/get-ftp-documents.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-item-references-by-model.action';
            binding.dataActions[actionPath] = require('partner/actions/get-item-references-by-model.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-roof-table.action';
            binding.dataActions[actionPath] = require('partner/actions/get-roof-table.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/lobas-article-page-summary/lobas-article-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/lobas-article-page-summary/lobas-article-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/lobas-product-page-summary/lobas-product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/lobas-product-page-summary/lobas-product-page-summary.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };